export default __webpack_public_path__ + "static/media/home-universe.91370ef9.png";